export default __webpack_public_path__ + "static/media/listedIcon.b2eb4ed6.svg";